import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {LatestModelStatus, RowDataReadingsDashboardData} from '@core/interfaces/live/live';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Co2LoadFaultIndicationDashboardData, Co2LoadUnits} from '@core/interfaces/live/co2-load';

@Injectable()
export class Co2LoadApi {
    private readonly PREFIX = 'live/output/co2-load';

    constructor(private api: HttpService) {}

    public getCo2LoadUnits(): Observable<Co2LoadUnits> {
        return this.api.get(`${this.PREFIX}/units`);
    }

    public getCo2LoadDatasource(id: string, filterss: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filterss);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getCo2LoadLatestModelStatus(assetId: string, uploadTime?: string): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getCo2LoadRowDataReadingsDashboardData(
        assetId: string,
        uploadTime?: string,
    ): Observable<RowDataReadingsDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/raw`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<RowDataReadingsDashboardData>) => res.response));
    }

    public getCo2LoadFaultIndicationDashboardData(
        assetId: string,
        uploadTime?: string,
    ): Observable<Co2LoadFaultIndicationDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/fault-indicator`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<Co2LoadFaultIndicationDashboardData>) => res.response));
    }
}
